/*
 * Era terminal item views (1970s/80s/90s/00s) let you read a record but had no
 * way to actually buy it. This wraps SATComponent.prototype.renderVals (same
 * technique as sat-home-featured-patch.js) to look each terminal record's fixed
 * archive code (e.g. "SAT-J774") up against a real product's custom.stock_code
 * metafield, and — when a match exists — swaps in that product's real price and
 * a working Add To Crate / Buy Now pair.
 *
 * The Classified/Restricted record (recRd, "UNCATALOGED FIELD ITEM ... WITHHELD")
 * is deliberately left without a buy control: its price is the string
 * "WITHHELD", not a number — it's written as a not-for-sale mystery item, not a
 * gap to fill.
 *
 * If a code has no matching real product yet, the buttons hide rather than show
 * a dead control — assign that code to a product's Stock code metafield
 * (Shopify admin → product → Metafields → Stock code, e.g. "J774" for the 1970s
 * radio) to bring it online.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }
  var orig = window.SATComponent.prototype.renderVals;
  window.SATComponent.prototype.renderVals = function () {
    var out = orig.call(this);
    var self = this;
    var products = this._products || [];

    function wireRecord(recKey, addKey, buyKey, labelKey, showKey) {
      var rec = out[recKey];
      if (!rec || !rec.code) { out[showKey] = 'none'; out[addKey] = function () {}; out[buyKey] = function () {}; return; }
      var id = String(rec.code).replace(/^SAT-?/i, '');
      var product = products.find(function (p) { return p.id === id; });
      if (!product || !product.variantId) {
        out[showKey] = 'none';
        out[addKey] = function () {};
        out[buyKey] = function () {};
        return;
      }
      var soldOut = product.stock <= 0;
      out[recKey] = Object.assign({}, rec, { price: '$' + product.price });
      out[showKey] = 'flex';
      out[labelKey] = soldOut ? 'Sold Out' : 'Add To Crate';
      out[addKey] = soldOut ? function () {} : function () { self.addToCart(product.id, 1); };
      out[buyKey] = soldOut ? function () {} : function () { self.addToCart(product.id, 1); self.placeOrder(); };
    }

    wireRecord('rec70', 'rec70Add', 'rec70Buy', 'rec70AddLabel', 'rec70BuyShow');
    wireRecord('rec80', 'rec80Add', 'rec80Buy', 'rec80AddLabel', 'rec80BuyShow');
    wireRecord('rec90', 'rec90Add', 'rec90Buy', 'rec90AddLabel', 'rec90BuyShow');
    wireRecord('rec00', 'rec00Add', 'rec00Buy', 'rec00AddLabel', 'rec00BuyShow');
    return out;
  };
})();
